<template>
	<div>
		<div class="title">
			<div class="title-desc">
				<div>{{ title }}</div>
				<CloseIcon  v-if="isClose" class="close-icon" @click="onClose()"/>
			</div>
			<v-btn
				class="title-btn rounded-pill"
				elevation="0"
				min-height="40"
				color="#00AAFD"
				:disabled="!is_active"
				@click="onUpdateWorklist"
			>
				search jobs
			</v-btn>
		</div>
		<v-expansion-panels accordion hover v-model="panel_local" multiple>
			<v-expansion-panel>
				<v-expansion-panel-header>Job numbers and title</v-expansion-panel-header>
				<v-expansion-panel-content class="content">
					<div class="number-row mb-5">
						<div class="number mr-3">
							<div class="text">From job no.</div>
							<v-text-field
								v-model="from_code"
								placeholder="From"
								outlined
								hide-details
								dense
								background-color="#FFFFFF"
							></v-text-field>
						</div>
						<div class="number">
							<div class="text">To job no.</div>
							<v-text-field
								v-model="to_code"
								placeholder="To"
								outlined
								hide-details
								dense
								background-color="#FFFFFF"
							></v-text-field>
						</div>
					</div>
					<div class="number">
						<div class="text">Job  Title</div>
						<v-text-field
							class="row"
							v-model="short"
							placeholder="Type to search..."
							outlined
							hide-details
							dense
							background-color="#FFFFFF"
						></v-text-field>
					</div>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel>
				<v-expansion-panel-header>Job status</v-expansion-panel-header>
				<v-expansion-panel-content class="content">
					<v-combobox
						v-if="statusses.length > combobox_visible"
						class="mb-0"
						v-model="statusses_select"
						:items="statusses"
						item-text="desc"
						multiple
						outlined
						dense
						hide-details
						clearable
						prepend-inner-icon="search"
						append-icon=""
						background-color="#FFFFFF"
					></v-combobox>
					<v-virtual-scroll
						:items="statusses"
						height="282"
						item-height="40"
					>
						<template v-slot:default="{ item }">
							<v-checkbox
								class="mt-0"
								v-model="statusses_select"
								color="info"
								dense
								hide-details
								multiple
								:label="item.desc"
								:value="item"
							></v-checkbox>
						</template>
					</v-virtual-scroll>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel>
				<v-expansion-panel-header>Job types</v-expansion-panel-header>
				<v-expansion-panel-content class="content">
					<v-combobox
						v-if="job_types.length > combobox_visible"
						class="mb-0"
						v-model="job_types_select"
						:items="job_types"
						item-text="desc"
						multiple
						outlined
						dense
						hide-details
						clearable
						prepend-inner-icon="search"
						append-icon=""
						background-color="#FFFFFF"
					></v-combobox>
					<v-virtual-scroll
						:items="job_types"
						height="200"
						item-height="40"
					>
						<template v-slot:default="{ item }">
							<v-checkbox
								v-model="job_types_select"
								color="info"
								dense
								hide-details
								multiple
								:label="item.desc"
								:value="item"
							></v-checkbox>
						</template>
					</v-virtual-scroll>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel @click="onLoadClient">
				<v-expansion-panel-header>Client details</v-expansion-panel-header>
				<v-expansion-panel-content class="content">
					<v-radio-group v-if="false" v-model="clientDetails_select" dense hide-details>
						<v-radio
							v-for="item in clientDetails"
							:key="item.id"
							:label="item.desc"
							:value="item.id"
							class="mt-0"
							color="info"
						></v-radio>
					</v-radio-group>
					<div class="text">Client name</div>
					<v-combobox
						v-model="clientDetails_search_select"
						:items="clientDetails_search"
						@click="onClearClientDetails"
						item-text="display_name"
						multiple
						class="mb-0"
						clearable
						outlined
						dense
						hide-details
						prepend-inner-icon="search"
						append-icon=""
						background-color="#FFFFFF"
					></v-combobox>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel v-if="false">
				<v-expansion-panel-header >Client types</v-expansion-panel-header>
				<v-expansion-panel-content class="content pt-0">
					<v-radio-group v-model="client_type" dense hide-details>
						<v-radio
							v-for="item in client_types"
							:key="item.id"
							:label="item.desc"
							:value="item.id"
							class="mt-0"
							color="info"
						></v-radio>
					</v-radio-group>
				</v-expansion-panel-content>
			</v-expansion-panel>
			<v-expansion-panel>
				<v-expansion-panel-header>Date Range</v-expansion-panel-header>
				<v-expansion-panel-content class="content">
					<div class="text">Date Type</div>
					<v-select
						v-model="data_range_select"
						:items="data_range"
						item-text="desc"
						item-value="id"
						outlined
						dense
						hide-details
						background-color="#FFFFFF"
					></v-select>
					<DateRange 
						class="mt-3"
						:color="'#CA66D2'"
						:dateStartInit="date_from_origin"
						:dateEndInit="date_end_origin"
						@dateStart="date_from = $event"
						@dateEnd="date_end = $event"
					/>
				</v-expansion-panel-content>
			</v-expansion-panel>
		</v-expansion-panels>
		<v-dialog
			class="dialog"
			v-model="dialog_visible"
			max-width="400"
			persistent
		>
			<v-alert
				border="top"
				colored-border
				color="warning"
				class="mb-0"
			>
				<div class="dialog-title-text">Are you sure?</div>
				<div class="dialog-content-text">This search has not been saved.</div>
				<div class="button">
					<div class="left" @click="onCancel()">Go back</div>
					<div class="right" @click="$emit('advanced-filter', false)">I’m sure, exit this search</div>
				</div>
			</v-alert>
		</v-dialog>
	</div>
</template>
<script>
import CloseIcon from '@/components/icons/close';
import DateRange from "@/components/date/date_range.vue";

import moment from 'moment';

const COMBOBOX_VISIBLE = 15; 
const STATUS_DEFAULT = {
	proposed: 'Proposed',
	live: 'Live'
};
const PANEL_ORDER = {
	from_code: 0,
	to_code: 0,
	short: 0,
	statusses: 1,
	job_types: 2,
	client: 3,
	invoice_from: 4,
	deadline_from: 4,
	entered_from: 4,
	opened_from: 4,
	status_change_from: 4,
	made_dead_from: 4
};
const DATA_RANGE = [
	{
		id: 'invoice',
		desc: 'Invoiced',
	},
	{
		id: 'deadline',
		desc: 'Deadline',
	},
	{
		id: 'entered',
		desc: 'Entered',
	},
	{
		id: 'opened',
		desc: 'Opened',
	},
	{
		id: 'status_change',
		desc: 'Status changed',
	},
	{
		id: 'made_dead',
		desc: 'Made dead',
	},
];
// const CLIENT_DETAIlS = [
// 	{
// 		id: 1,
// 		desc: 'Clients',
// 	},
// 	{
// 		id: 14,
// 		desc: 'Prospect',
// 	}
// ];
// const CLIENT_TYPES = [
// 	{
// 		id: 0,
// 		desc: 'All related parties'
// 	},
// 	{
// 		id: 1,
// 		desc: 'Non-related parties'
// 	},
// 	{
// 		id: 2,
// 		desc: 'Related parties'
// 	}
// ];

export default {
	name: 'SearchAdvance',
	components: {
		CloseIcon,
		DateRange
	},
	props: {
		title: {
			type: String,
			default: 'Search'
		},
		settings: {
			type: Object,
			default: () => {}
		},
		statusses: {
			type: Array,
			default: () => []
		},
		job_types: {
			type: Array,
			default: () => []
		},
		isClose: {
			type: Boolean,
			default: false
		},
		panel: {
			type: Array,
			default: () => []
		}
	},
	data() {
		return {
			panel_local: this.panel,
			combobox_visible: COMBOBOX_VISIBLE,
			is_active: false,
			dialog_visible: false,

			from_code: '',
			to_code: '',
			short: '',

			statusses_select: [],
			job_types_select: [],

			clientDetails_search: [],
			clientDetails_search_select: null,

			data_range: DATA_RANGE,
			data_range_select: '',
			data_range_select_origin: '',

			date_from: '',
			date_from_origin: '',

			date_end: '',
			date_end_origin: '',

			// clientDetails: CLIENT_DETAIlS,
			// clientDetails_select:  null,
			// client_types: CLIENT_TYPES,
			// client_type: 0,
		}
	},
	created() {
		this._load_client();
		this.setting_init();
		if (!this.settings) {
			this.statusses_select = this.statusses_select = this.statusses.filter(status => {
				return status.desc === STATUS_DEFAULT.proposed || status.desc === STATUS_DEFAULT.live
			});
		}
		
		// this.init_clientDetails_select();
		// /api/addressbook/meta;
	},
	watch: {
		statusses() {
			if (this.statusses.length !== 0 && !this.settings) {
				this.statusses_select = this.statusses.filter(status => {
					return status.desc === STATUS_DEFAULT.proposed || status.desc === STATUS_DEFAULT.live
				});
			}
		},
		settings() {
			if (this.settings) {
				this.setting_init();
			}
		},
		from_code() {
			if (this.settings && this.settings.from_code && this.settings.from_code.length !== 0) {
				if (this.settings.from_code !== this.from_code) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			} else {
				if (this.from_code.length !== 0) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			}
		},
		to_code() {
			if (this.settings && this.settings.to_code && this.settings.to_code.length !== 0) {
				if (this.settings.to_code !== this.to_code) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			} else {
				if (this.to_code.length !== 0) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			}
		},
		short() {
			if (this.settings && this.settings.short && this.settings.short.length !== 0) {
				if (this.settings.short !== this.short) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			} else {
				if (this.short.length !== 0) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			}
		},
		statusses_select() {
			if (this.settings && this.settings.statusses && this.settings.statusses.length !== 0) {
				if (this.settings.statusses.length !== this.statusses_select.length) {
					this.is_active = true;
				} else {
					const arr_tmp = this.statusses_select.map(status => {return status.id});
					const A = arr_tmp.sort().toString();
					const B =  this.settings.statusses.sort().toString();
					if (A !== B) {
						this.is_active = true;
					} else {
						this.is_active = false;
					}
				}
			} else {
				if (this.statusses_select.length > 0) {
					this.is_active = true;
				} 
				// if (this.statusses_select.length > 0 && this.statusses_select.length !== 2) {
				// 	this.is_active = true;
				// } else if(this.statusses_select.length > 0) {
				// 	const result0 = this.statusses_select.find(status => status.desc === STATUS_DEFAULT.proposed);
				// 	const result1 = this.statusses_select.find(status => status.desc === STATUS_DEFAULT.live);
				// 	if (!result0 || !result1) {
				// 		this.is_active = true;
				// 	} else {
				// 		this.is_active = false;
				// 	}
				// }
			}
		},
		job_types_select() {
			if (this.settings && this.settings.job_types && this.settings.job_types.length !== 0) {
				if (this.settings.job_types !== this.job_types_select) {
					this.is_active = true;			
				} else {
					this.is_active = false;
				}
			} else {
				if (this.job_types_select.length !== 0) {
					this.is_active = true;			
				} else {
					this.is_active = false;
				}
			}
		},
		clientDetails_search_select() {
			if (this.settings && this.settings.client && (this.settings.client !== 0 || this.settings.client.length !== 0)) {
				if (Array.isArray(this.settings.client)) {
					if (this.settings.client.length !== this.clientDetails_search_select.length) {
						this.is_active = true;
					} else if(this.settings.client.length === this.clientDetails_search_select.length) {
						const client_arr = this.clientDetails_search_select.map(client => {return client.id} );
						const settings_client_arr = this.settings.client;

						client_arr.sort();
						settings_client_arr.sort();
						
						const A = client_arr.toString();
						const B = settings_client_arr.toString();
						if (A !== B) {
							this.is_active = true;	
						} else {
							this.is_active = false;
						}
					}
					
				} else {
					if (this.settings.client !== this.clientDetails_search_select) {
						this.is_active = true;	
					} else {
						this.is_active = false;
					}
				}
				
			} else {
				if (this.clientDetails_search_select.length !== 0) {
					this.is_active = true;			
				} else {
					this.is_active = false;
				}
			}
		},
		data_range_select() {
			const condition = this.settings && this.settings.deadline_from && this.settings.deadline_from.length !== 0 
				|| this.settings && this.settings.invoice_from && this.settings.invoice_from.length !== 0 
				|| this.settings && this.settings.entered_from && this.settings.entered_from.length !== 0 
				|| this.settings && this.settings.opened_from && this.settings.opened_from.length !== 0 
				|| this.settings && this.settings.made_dead_from && this.settings.made_dead_from.length !== 0 
				|| this.settings && this.settings.status_change_from && this.settings.status_change_from.length !== 0 ;

			if (condition) {
				if (this.data_range_select_origin !== this.data_range_select) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			} else {
				if (this.data_range_select.length !== 0 && this.date_from && this.date_end && this.date_from <= this.date_end) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			}

		},
		date_from() {
			const condition = this.settings && this.settings.deadline_from && this.settings.deadline_from.length !== 0 
				|| this.settings && this.settings.invoice_from && this.settings.invoice_from.length !== 0 
				|| this.settings && this.settings.entered_from && this.settings.entered_from.length !== 0 
				|| this.settings && this.settings.opened_from && this.settings.opened_from.length !== 0 
				|| this.settings && this.settings.made_dead_from && this.settings.made_dead_from.length !== 0 
				|| this.settings && this.settings.status_change_from && this.settings.status_change_from.length !== 0 ;

			if (condition) {
				if (this.date_from_origin !== this.date_from && this.date_from && this.date_end && this.date_from <= this.date_end) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			} else {
				if (this.data_range_select.length !== 0 && this.date_from && this.date_end && this.date_from <= this.date_end) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			}
		},
		date_end() {
			const condition = this.settings && this.settings.deadline_from && this.settings.deadline_from.length !== 0 
				|| this.settings && this.settings.invoice_from && this.settings.invoice_from.length !== 0 
				|| this.settings && this.settings.entered_from && this.settings.entered_from.length !== 0 
				|| this.settings && this.settings.opened_from && this.settings.opened_from.length !== 0 
				|| this.settings && this.settings.made_dead_from && this.settings.made_dead_from.length !== 0 
				|| this.settings && this.settings.status_change_from && this.settings.status_change_from.length !== 0 ;

			if (condition) {
				if (this.date_end_origin !== this.date_end && this.date_from && this.date_end && this.date_from <= this.date_end) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			} else {
				if (this.data_range_select.length !== 0 && this.date_from && this.date_end && this.date_from <= this.date_end) {
					this.is_active = true;
				} else {
					this.is_active = false;
				}
			}
		},
	},
	methods: {
		async setting_init() {
			if (!this.settings) return;
			
			this.panel_local = [];

			if (this.settings.from_code && this.settings.from_code.length !== 0) {
				this.from_code = this.settings.from_code;
				const index = PANEL_ORDER.from_code;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.to_code && this.settings.to_code.length !== 0) {
				this.to_code = this.settings.to_code;
				const index = PANEL_ORDER.to_code;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.short && this.settings.short.length !== 0) {
				this.short = this.settings.short;
				const index = PANEL_ORDER.short;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.statusses && this.settings.statusses.length !== 0) {
				this.statusses_select = [];
				this.statusses.forEach(status => {
					if (this.settings.statusses.includes(status.id)) {
						this.statusses_select.push(status);
					}
				});
				const index = PANEL_ORDER.statusses;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			} else {
				this.statusses.forEach(status => {
					if (status.desc === STATUS_DEFAULT.proposed || status.desc === STATUS_DEFAULT.live) {
						this.statusses_select.push(status);
					}
				});
			}

			if (this.settings.job_types && this.settings.job_types.length !== 0) {
				this.job_types_select = this.settings.job_types;
				const index = PANEL_ORDER.job_types;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}
			
			if (this.settings.client && (this.settings.client !== 0 || this.settings.client.length !== 0)) {
				await this._load_client();
				if (Array.isArray(this.settings.client)) {
					const clientDetail = this.clientDetails_search.filter(arr => {
						return this.settings.client.includes(arr.id);
					});
					this.clientDetails_search_select = clientDetail;

				} else {
					const clientDetail = this.clientDetails_search.filter(arr => {
						return arr.id === this.settings.client;
					});
					this.clientDetails_search_select = clientDetail[0];
				}

				const index = PANEL_ORDER.client;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.invoice_from != null && this.settings.invoice_to != null) {
				this.data_range_select = 'invoice';
				this.data_range_select_origin = 'invoice';

				this.date_from = moment(this.settings.invoice_from).format('YYYY-MM-DD');
				this.date_end = moment(this.settings.invoice_to).format('YYYY-MM-DD');

				this.date_from_origin = moment(this.settings.invoice_from).format('YYYY-MM-DD');
				this.date_end_origin = moment(this.settings.invoice_to).format('YYYY-MM-DD');

				const index = PANEL_ORDER.invoice_from;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.deadline_from != null && this.settings.deadline_to != null) {
				this.data_range_select = 'deadline';
				this.data_range_select_origin = 'deadline';

				this.date_from = moment(this.settings.deadline_from).format('YYYY-MM-DD');
				this.date_end = moment(this.settings.deadline_to).format('YYYY-MM-DD');

				this.date_from_origin = moment(this.settings.deadline_from).format('YYYY-MM-DD');
				this.date_end_origin = moment(this.settings.deadline_to).format('YYYY-MM-DD');

				const index = PANEL_ORDER.deadline_from;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.entered_from != null && this.settings.entered_to != null) {
				this.data_range_select = 'entered';
				this.data_range_select_origin = 'entered';

				this.date_from = moment(this.settings.entered_from).format('YYYY-MM-DD');
				this.date_end = moment(this.settings.entered_to).format('YYYY-MM-DD');

				this.date_from_origin = moment(this.settings.entered_from).format('YYYY-MM-DD');
				this.date_end_origin = moment(this.settings.entered_to).format('YYYY-MM-DD');

				const index = PANEL_ORDER.entered_from;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.opened_from != null && this.settings.opened_to != null) {
				this.data_range_select = 'opened';
				this.data_range_select_origin = 'opened';

				this.date_from = moment(this.settings.opened_from).format('YYYY-MM-DD');
				this.date_end = moment(this.settings.opened_to).format('YYYY-MM-DD');

				this.date_from_origin = moment(this.settings.opened_from).format('YYYY-MM-DD');
				this.date_end_origin = moment(this.settings.opened_to).format('YYYY-MM-DD');

				const index = PANEL_ORDER.opened_from;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.status_change_from != null && this.settings.status_change_to != null) {
				this.data_range_select = 'status_change';
				this.data_range_select_origin = 'status_change';

				this.date_from = moment(this.settings.status_change_from).format('YYYY-MM-DD');
				this.date_end = moment(this.settings.status_change_to).format('YYYY-MM-DD');

				this.date_from_origin = moment(this.settings.status_change_from).format('YYYY-MM-DD');
				this.date_end_origin = moment(this.settings.status_change_to).format('YYYY-MM-DD');

				const index = PANEL_ORDER.status_change_from;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}

			if (this.settings.made_dead_from != null && this.settings.made_dead_to != null) {
				this.data_range_select = 'made_dead';
				this.data_range_select_origin = 'made_dead';

				this.date_from = moment(this.settings.made_dead_from).format('YYYY-MM-DD');
				this.date_end = moment(this.settings.made_dead_to).format('YYYY-MM-DD');

				this.date_from_origin = moment(this.settings.made_dead_from).format('YYYY-MM-DD');
				this.date_end_origin = moment(this.settings.made_dead_to).format('YYYY-MM-DD');

				const index = PANEL_ORDER.made_dead_from;
				if (!this.panel_local.includes(index)) {
					this.panel_local.push(index);
				}
			}
		},
		onClose() {
			if (this.is_active) {
				this.dialog_visible = true;
			} else {
				this.$emit('advanced-filter');
			}
		},
		onCancel() {
			this.dialog_visible = false;
		},
		onUpdateWorklist() {
			if (this.is_active) {
				const params = {
					from_code: this.from_code,
					to_code: this.to_code,
					short: this.short,
					job_types: this.job_types_select.length !== 0 ? this.job_types_select.map(job_type => job_type.id): null,
					statusses: this.statusses_select.map(status => status.id),
					client: this.clientDetails_search_select && this.clientDetails_search_select.length !== 0 ? this.clientDetails_search_select.map(client => { return client.id}) : null,
					status_groups: [ 0, 1, 2 ],
					show_columns: null,
					sort_columns: null,
					invoice_from: this.data_range_select === 'invoice' && this.date_from.length !== 0 ? moment(this.date_from).format('YYYYMMDD') : null ,
					invoice_to: this.data_range_select === 'invoice' && this.date_end.length !== 0 ? moment(this.date_end).format('YYYYMMDD') : null,
					deadline_from: this.data_range_select === 'deadline' && this.date_from.length !== 0 ? moment(this.date_from).format('YYYYMMDD') : null ,
					deadline_to: this.data_range_select === 'deadline' && this.date_end.length !== 0 ? moment(this.date_end).format('YYYYMMDD') : null,
					entered_from: this.data_range_select === 'entered' && this.date_from.length !== 0 ? moment(this.date_from).format('YYYYMMDD') : null ,
					entered_to: this.data_range_select === 'entered' && this.date_end.length !== 0 ? moment(this.date_end).format('YYYYMMDD') : null,
					opened_from: this.data_range_select === 'opened' && this.date_from.length !== 0 ? moment(this.date_from).format('YYYYMMDD') : null ,
					opened_to: this.data_range_select === 'opened' && this.date_end.length !== 0 ? moment(this.date_end).format('YYYYMMDD') : null,
					status_change_from: this.data_range_select === 'status_change' && this.date_from.length !== 0 ? moment(this.date_from).format('YYYYMMDD') : null ,
					status_change_to: this.data_range_select === 'status_change' && this.date_end.length !== 0 ? moment(this.date_end).format('YYYYMMDD') : null,
					made_dead_from: this.data_range_select === 'made_dead' && this.date_from.length !== 0 ? moment(this.date_from).format('YYYYMMDD') : null ,
					made_dead_to: this.data_range_select === 'made_dead' && this.date_end.length !== 0 ? moment(this.date_end).format('YYYYMMDD') : null,
				};
				
				this.is_active = false;
				this.$emit('update-search', params);
			}
		},
		init_clientDetails_select() {
			this.clientDetails_select = this.clientDetails[0].id;
			// this.clientDetails.forEach(item => {
			// 	this.clientDetails_select = item.id;
			// });
		},
		onLoadClient() {
			this._load_client();
		},
		onClearClientDetails() {
			this.clientDetails_select = null;
		},
		async _load_client() {
			const types = '1,14'; // 1=client, 14=prospects
			const params = [];
			// params.push("name=" + encodeURIComponent(v));
			params.push("abook_types=" + encodeURIComponent(types));

			let url = "/api/addressbook";
			if (params.length > 0) {
				url+= "?" + params.join('&');
			}
			await axios
				.get(url, {
					headers: {
						"Authorization": "Bearer " + this.$store.state.token,
						"Accept": "application/json"
					}
				})
				.then((val) => {
					const json = val.data;

					if (typeof(json) == "string") {
						json = JSON.parse(json);
					}
					const { status, data } = json;

					if (status == "OK") {
						this.clientDetails_search = data;
					} 
				})
				.catch((e) => {
					this.errormsg = e.message;
				});
		},
	}
}
</script>
<style lang="scss" scoped>
.title {
	padding: 14px 24px;
	background: #FFFFFF;
	border-radius: 4px 4px 0 0;
	border: 1px solid #C9C9C9;
	border-bottom: none;
	display: flex;
	flex-flow: column nowrap;
	// justify-content: flex-start;
	align-items: center;
	font-family: Roboto;
	font-style: normal;
	font-weight: bold;
	font-size: 16px;
	line-height: 24px;
	color: #192A3E;
}
.title-desc {
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
	align-items: center;
	width: 100%;
}
.title-btn {
	width: 100%;
	margin-top: 12px;
	font-family: Roboto;
	font-style: normal;
	font-weight: 500;
	font-size: 14px;
}
.title-btn-able {
	color: #FFFFFF;
	background: #00AAFD;
	&:hover {
		cursor: pointer;
	}
}
.title-btn-disable {
color: #FFFFFF;
	background: #00AAFD;
}
.close-icon {
  width: 20px;
  height: 20px; 
	margin-right: 2px;
  &:hover {
    cursor: pointer;
  }
}
.content {
	background: rgba(25, 42, 62, 0.1);
	padding-top: 16px;
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-start;
}
.number-row {
	width: 100%;
	display: flex;
	flex-flow: row nowrap;
	justify-content: space-between;
}
.number {
	display: flex;
	flex-flow: column nowrap;
	justify-content: flex-start;
}
.text {
	font-family: Roboto;
	font-style: normal;
	font-weight: normal;
	font-size: 14px;
	line-height: 20px;
	color: #37495F;
	margin-bottom: 8px;
}
.dialog {
	padding: 20px;
}
.dialog-title-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  line-height: 24px;
  color: #000000;
	margin-top: 8px;
}
.dialog-content-text {
  font-family: Roboto;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 20px;
  color: #000000;
  margin: 28px 0;
}
.button {
  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
  align-items: center;
	.left {
		border: 1px solid rgba(25, 42, 62, 0.7);
		border-radius: 4px;
		color: rgba(25, 42, 62, 0.7);
		padding: 0 16px;
		margin-right: 12px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 36px;
		&:hover {
    	cursor: pointer;
  	}
	}
	.right {
		border: 1px solid #00AAFD;
		border-radius: 4px;
		background: #00AAFD;
		color: #FFFFFF;
		padding: 0 16px;
		font-family: Roboto;
		font-style: normal;
		font-weight: 500;
		font-size: 14px;
		line-height: 36px;
		&:hover {
    	cursor: pointer;
  	}
	}
}
.theme--light.v-btn {
  color: #FFFFFF;
}
.v-expansion-panels {
	border-radius: 0 0 4px 4px;
	border: 1px solid #C9C9C9;
}
.v-expansion-panel--active > .v-expansion-panel-header {
	min-height: 48px;
}
</style>